import { QueryCache, QueryClient } from '@tanstack/react-query';
import { ApiError } from '@/lib/apiClient';

export function createQueryClient() {
  const client: QueryClient = new QueryClient({
    queryCache: new QueryCache({
      // A 401 from any query means the session ended: re-check ['me'] so the app flips to guest.
      onError: (err, query) => {
        if (err instanceof ApiError && err.status === 401 && query.queryKey[0] !== 'me') {
          void client.invalidateQueries({ queryKey: ['me'] });
        }
      },
    }),
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        refetchOnWindowFocus: true,
        // Retry only network failures and 5xx, at most twice; never 4xx.
        retry: (count, err) =>
          count < 2 && err instanceof ApiError && (err.status === 0 || err.status >= 500),
      },
      mutations: { retry: 0 },
    },
  });
  return client;
}

export const queryClient = createQueryClient();
